module.exports = __webpack_public_path__ + "img/BGSULogo_21-02-01_nmyb5a.83fc47d8.png";